export const HelpCenterURL = "https://helpcenter.ttaconnect.com"
export const InviteContactURL = "https://helpcenter.ttaconnect.com/topics/invite-company-contacts/"